import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { countries, devConfig, profile } from 'config/config'; // Importing configuration variables

/**
 * Class representing the FilterReferralsAwardsReportsView.
 * @extends JetView
 */
export default class FilterReferralsAwardsReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Left section containing input fields for filtering
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for Referent ID
                            name: 'ReferentId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id del referente'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('Id del referente'),
                        },
                        {
                            view: 'text', // Input for Referred ID
                            name: 'ReferredId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id del referido'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('Id del referido'),
                        },
                        {
                            view: 'text', // Input for Award ID
                            name: 'AwardId',
                            type: 'number',
                            minWidth: 200,
                            label: _('Id del premio'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('Id del premio'),
                        },
                        {
                            view: 'text', // Input for Redemption Date
                            minWidth: 200,
                            name: 'RedemptionDate',
                            id: 'RedemptionDate',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de modificación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for Condition Type
                            name: 'ConditionType',
                            id: 'ConditionType',
                            label: _('Condición'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Mínimo primer depósito') },
                                {
                                    id: '2',
                                    value: _('Mínimo valor en apuestas'),
                                },
                                { id: '3', value: _('Cuenta verificada') },
                            ],
                        },
                        {},
                        {},
                        {},
                    ],
                },
            ],
        };

        // Upper section containing the left section
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    width: 140,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    type: 'form',
                    width: 140,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        this.app.callEvent('referralsAwardsReport:filter', [
                            filterdata, // Calls event with filter data
                        ]);
                    },
                },
            ],
        };

        // Accordion section for filters
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Main return object for the view
        return {
            view: 'form',
            type: 'clean',
            autofit: true,
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Conditional rendering based on screen size
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('RedemptionDate').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
